import(/* webpackMode: "eager" */ "/vercel/path0/app/federal/awards/page.tsx");
